import React from "reactn";
import { StepIndicator } from "../../../components/UI";
import Setup from "./Setup";
import AdditionalDetails from "./AdditionalDetails";
import CreatePackage from "./CreatePackage";
import StepBar from "../../../components/UI/StepBar";
import Validators from "../../../validators";
import WaitlistAcceptModal from "../../../components/modals/WaitlistAcceptModal";
import { canUserCreate } from "../../../utilities/listingCreation";
import axios from "axios";
import { toast } from "react-toastify";

class PartiesSetup extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      step: 0, // Section of the form currently active.
      canUserMakeNewParty: false,
      makePartyReqMessage: "",
      birthdayParty: true,
      showWaitlistAcceptModal: false,
      waitlistData: {
        totalSpots: 0,
        currentSpots: 0,
        waitlistedSpots: 0,
        pendingSpots: 0,
        applicationRequired: false
      }
    };
    this.titles = ["Set-Up", "Create Package", "Additional Settings"];
    this.validate = [
      () => Validators.Partners.Profile.ValidatePartiesOne(this.global.party),
      () => Validators.Partners.Profile.ValidatePartiesTwo(this.global.party),
      () => Validators.Partners.Profile.ValidatePartiesThree(this.global.party)
    ];
    this.steps = [
      { name: "Set-Up", validateFn: this.validate[0] },
      { name: "Create Package", validateFn: this.validate[1] },
      { name: "Additional Settings", validateFn: this.validate[2] }
    ];
  }

  async componentDidMount() {
    const canUserMake = await canUserCreate("party");
    const makePartyReqMessage = canUserMake.message;
    console.log("HERE", canUserMake);
    this.setState({
      canUserMakeNewParty: canUserMake.success,
      makePartyReqMessage: makePartyReqMessage
    });
    if (this.props.match.params.id) {
      await this.dispatch.getParty(this.props.match.params.id);
    } else {
      if (!this.props.location.state?.fromAIModal) {
        await this.dispatch.resetEvent();
      }
    }

    this.setGlobal({
      partnerPathway: [
        ...this.global.partnerPathway.slice(0, 1),
        { label: "Parties", to: "/parties/list" },
        {
          label: this.global.party.party_title || "Parties Setup",
          to: this.props.location.pathname.replace(/^\/partners/, "") // remove /partners from pathname
        }
      ]
    });
  }

  /**
   * To be run before saving. If any page is not setup correctly, it will unpublish the page.
   */
  ensureValidPublish = () => {
    // If the page is currently published
    if (this.global.party.published) {
      // Check validity of all pages
      for (let i = 0; i < this.steps.length; i++) {
        if (this.checkValid(i)) {
          // If any page is invalid, set publish to false
          this.setGlobal({
            party: {
              ...this.global.party,
              published: false
            }
          });
          break;
        }
      }
    }
  };

  acceptWaitlist = async () => {
    const { totalSpots, currentSpots, waitlistedSpots, pendingSpots } =
      this.state.waitlistData;

    const availableSpots = totalSpots - currentSpots - pendingSpots;

    const amountMoved = Math.min(availableSpots, waitlistedSpots);

    if (amountMoved <= 0) {
      console.log("No spots available or no one on waitlist.");
      return;
    }
    let waitlistedUsers = [];
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}/partners/parties/customers/listing/${this.global.party.id}`
      );
      if (res.data.success) {
        console.log("response", res.data);
        waitlistedUsers = res.data.data
          .filter(item => item.status_stage === "Waitlisted_Unpaid")
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        console.log("waitlistedUsers", waitlistedUsers);
      }
    } catch (err) {
      console.error("Error fetching spots:", err);
      return;
    }

    const usersToAccept = waitlistedUsers.slice(0, availableSpots);
    if (usersToAccept.length === 0) {
      console.log("No waitlisted users to accept.");
      return;
    }
    let successCount = 0;
    console.log("usersToAccept", usersToAccept);

    for (const user of usersToAccept) {
      console.log("user to accept", user);
      try {
        const ep = `${process.env.REACT_APP_API}/partners/parties/customers/application_accept/${user.id}`;

        const result = await axios.put(ep, {
          status_stage: "Accepted_Unpaid",
          message: "Automated waitlist acceptance due to increased capacity.",
          childName: user.childName
        });

        if (result.data.success) {
          successCount++;
          console.log("waitlist to accept success");
        }
      } catch (err) {
        console.error(`Failed to process user ${user.id}:`, err);
      }
    }

    if (successCount > 0) {
      toast.success(
        `Successfully accepted ${successCount} users from the waitlist!`
      );
      this.setState({ showWaitlistAcceptModal: false });
    } else {
      toast.error("Failed to process waitlist rollovers.");
    }
  };

  handleSave = async e => {
    console.log("HANDLE SAVE");
    const party = this.global.party;

    let totalSpots = party.total_spots || 0;
    let currentSpots = 0;
    let waitlistedSpots = 0;
    let pendingSpots = 0;
    let enabledWaitlist = party.enable_waitlist;
    let applicationRequired = party.application_required;
    let selectedParty;

    try {
      const ep = await axios.get(
        `${process.env.REACT_APP_API}/partners/parties/list_manage`
      );
      if (ep.data.success) {
        console.log("EP DATA: ", ep.data.data);
        selectedParty = ep.data.data.find(e => e.id === party.id);
        console.log("SELECTED PARTY: ", selectedParty);
        let tickets = selectedParty.tickets.map(t => JSON.parse(t));
        console.log("TICKETS: ", tickets);
        let ticketCount = 0;
        for (let ticket of tickets) {
          if (ticket.active !== false) {
            ticketCount += Number(ticket.ticket_quantity);
          }
        }
        console.log("TICKET COUNT: ", ticketCount);
        totalSpots = ticketCount;
        currentSpots = selectedParty.enrolledNum;
      } else {
        console.log("error");
      }
      // Fetch waitlisted spots
      const res = await axios.get(
        `${process.env.REACT_APP_API}/partners/parties/enrollments/waitlisted/${party.id}`
      );
      if (res.data.success) {
        waitlistedSpots = res.data.data.count;
      }

      // Fetch current enrolled spots
      const res2 = await axios.get(
        `${process.env.REACT_APP_API}/partners/parties/enrollments/count/${party.id}`
      );
      if (res2.data.success) {
        currentSpots = res2.data.data.count;
      }

      const res3 = await axios.get(
        `${process.env.REACT_APP_API}/partners/virtual/customers/listing/${this.global.party.id}`
      );
      if (res3.data.success) {
        const twoDaysAgo = new Date();
        twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
        console.log("twoDaysAgo: ", twoDaysAgo);
        console.log("response", res3.data);
        pendingSpots = res3.data.data.filter(
          item =>
            (item.status_stage === "Direct_Unpaid" ||
              item.status_stage === "Accepted_Unpaid") &&
            item.updatedAt &&
            new Date(item.createdAt) > twoDaysAgo
        );
      }
    } catch (err) {
      console.error("Error fetching spots:", err);
    }
    // pendingSpots = 0; // Temporarily set pending spots to 0
    let availSpots = Number(currentSpots) + Number(pendingSpots);
    console.log("avail", availSpots);

    const showModal =
      enabledWaitlist === true &&
      applicationRequired === false &&
      totalSpots > availSpots &&
      waitlistedSpots > 0;

    // Update both flags and waitlist data in state
    this.setState({
      showWaitlistAcceptModal: showModal,
      waitlistData: {
        totalSpots,
        currentSpots,
        waitlistedSpots,
        pendingSpots,
        applicationRequired
      }
    });
    console.log("waitlist data", this.state.waitlistData);

    return showModal;
  };

  saveProfile = async e => {
    const { step } = this.state;

    this.ensureValidPublish();

    switch (e.target.name) {
      case "next":
        this.setState({ step: step + 1 });
        await this.dispatch.saveParty();
        break;
      case "back":
        this.setState({ step: step - 1 });
        await this.dispatch.saveParty();
        break;
      case "save":
        await this.dispatch.saveParty();
        break;
      default:
        return;
    }
  };

  changePage = async page => {
    this.ensureValidPublish();
    if (!this.checkValid()) {
      // Only allow the user to progress to the earliest invalid page
      for (let i = 0; i < page; i++) {
        if (this.checkValid(i)) {
          return; // Prparty the page from changing
        }
      }
      await this.dispatch.saveParty();
      this.setState({ step: page });
    } else if (page < this.state.step) {
      // Allow the user to backtrack to previous pages
      await this.dispatch.saveParty();
      this.setState({ step: page });
    }
  };

  getPage = () => {
    switch (this.state.step) {
      case 0:
        return (
          <Setup
            initialPartyType={
              this.props.location.state
                ? this.props.location.state.partyType
                : this.global.party.partyType
            }
            initialAddChild={
              this.props.location.state
                ? this.props.location.state.addChild
                : this.global.party.addChild
            }
            initialManualInvoices={
              this.props.location.state
                ? this.props.location.state.manualInvoices
                : this.global.party.manual_invoices
            }
            initialApplicationRequired={
              this.props.location.state
                ? this.props.location.state.applicationRequired
                : this.global.party.application_required
            }
            allowSameEnrollment={
              this.props.location.state
                ? this.props.location.state.allowSameEnrollment
                : this.global.party.allowSameEnrollment
            }
            birthdayParty={
              this.props.location.state
                ? this.props.location.state.birthdayParty
                : this.global.party.birthdayParty
            }
          />
        );
      case 1:
        return (
          <CreatePackage
            match={this.props.match}
            partyType={this.global.party.partyType}
          />
        );
      case 2:
        return <AdditionalDetails />;
      default:
        return <Setup />;
    }
  };

  checkValid(step = this.state.step) {
    return this.validate[step] && !this.validate[step]();
  }

  getCompletion() {
    let completed = 0;
    for (let v of this.validate) {
      completed += v();
    }
    return (completed / this.validate.length) * 100;
  }

  render() {
    if (!this.state.canUserMakeNewParty && !this.props.match.params.id) {
      return (
        <div className="container-fluid">
          {/* Commented out to make space for Top Bar */}
          {/* <div className="cont">
            <h1 className="parties-title-header">Parties</h1>
          </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              height: "50vh",
              alignItems: "center"
            }}
          >
            <p>{this.state.makePartyReqMessage}</p>
          </div>
        </div>
      );
    }
    return (
      <>
        {this.state.showWaitlistAcceptModal && (
          <WaitlistAcceptModal
            onSubmit={() => {
              this.acceptWaitlist();
              this.saveProfile({ target: { name: "save" } });
            }}
            onManual={() => this.saveProfile({ target: { name: "save" } })} // New prop for manual
            onClose={_ => this.setState({ showWaitlistAcceptModal: false })}
            totalSpots={this.state.waitlistData.totalSpots} // total program spots
            currentSpots={this.state.waitlistData.currentSpots} // currently enrolled
            waitlistedSpots={this.state.waitlistData.waitlistedSpots} // waitlisted count
            pendingSpots={this.state.waitlistData.pendingSpots}
            applicationRequired={this.state.waitlistData.applicationRequired} // true/false
          />
        )}
        <div className="container-fluid">
          {/* Commented out to make space for Top Bar */}
          {/* <div className="cont">
          <h1 className="parties-title-header">Parties</h1>
        </div> */}
          <StepBar
            {...{
              steps: this.steps,
              changeFn: this.changePage,
              current: this.state.step
            }}
          />
          <StepIndicator value={this.getCompletion()} />
          {this.getPage()}
          <div className="cont mb-5">
            <div
              className="buttons w-100"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end"
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "80%"
                }}
              >
                <div
                  name="back"
                  disabled={this.state.step === 0}
                  onClick={e => {
                    e.target.name = "back";
                    if (this.state.step === 0) return;
                    this.saveProfile(e);
                  }}
                  style={{
                    transform:
                      window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                    display: "inline-block",
                    transformOrigin: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i
                    name="back"
                    style={{
                      paddingRight: window.innerWidth < 768 ? "20px" : "24px"
                    }}
                    className={`fas fa-chevron-left ${
                      this.state.step === 0
                        ? "listing-step-btn-inactive"
                        : "listing-step-btn-active"
                    }`}
                  ></i>
                </div>
                <div
                  name="next"
                  onClick={e => {
                    e.target.name = "next";
                    if (
                      this.state.step === this.titles.length - 1 ||
                      this.checkValid()
                    )
                      return;
                    this.saveProfile(e);
                  }}
                  style={{
                    transform:
                      window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                    display: "inline-block",
                    transformOrigin: "left",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <i
                    name="next"
                    style={{
                      paddingLeft: window.innerWidth < 768 ? "20px" : "24px"
                    }}
                    className={`fas fa-chevron-right ${
                      this.state.step === this.titles.length - 1 ||
                      this.checkValid()
                        ? "listing-step-btn-inactive"
                        : "listing-step-btn-active"
                    }`}
                  ></i>
                </div>
              </div>
              {/* <button
              onClick={this.saveProfile}
              disabled={this.state.step === 0}
              name="back"
              className="nextbtn"
            >
              BACK
            </button> */}
              <div
                style={{
                  width: "15%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end"
                }}
              >
                {this.state.step === this.titles.length - 1 && (
                  <button
                    onClick={_ => {
                      this.setGlobal(
                        {
                          party: {
                            ...this.global.party,
                            published: !this.global.party.published
                          }
                        },
                        _ => this.dispatch.saveParty()
                      );
                    }}
                    name="save"
                    className={
                      this.checkValid() ? "nextbtnDisabled" : "nextbtn"
                    }
                    disabled={this.checkValid()}
                    style={{
                      transform:
                        window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                      display: "inline-block",
                      transformOrigin: "right"
                    }}
                  >
                    {this.global.party.published ? "Unpublish" : "Publish"}
                  </button>
                )}
                <button
                  onClick={async e => {
                    const target = e.currentTarget;
                    const showModal = await this.handleSave();

                    if (!showModal) {
                      target.name = "save";
                      this.saveProfile({ target: target });
                    }
                  }}
                  name="save"
                  className="savebtn"
                  disabled={this.checkValid()}
                  style={{
                    background: "#b2b8c7",
                    border: "1px solid #b2b8c7",
                    transform:
                      window.innerWidth < 768 ? "scale(0.8)" : "scale(1)",
                    display: "inline-block",
                    transformOrigin: "right"
                  }}
                >
                  SAVE
                </button>
              </div>

              {/* <button
              onClick={this.saveProfile}
              disabled={
                this.checkValid() || this.state.step === this.titles.length - 1
              }
              name="next"
              className="nextbtn"
            >
              NEXT
            </button> */}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PartiesSetup;
